import { StyleSheet } from 'aphrodite';

export const styles = StyleSheet.create({
    
    page : {
        backgroundColor: "#f5f6f9ff"
    },

    loader: {
        marginTop: "40px",
        marginLeft: "auto",
        marginRight: "auto"
    },

    author_info_container: {
        marginTop: 30,
        marginLeft: 50
    },
   
    author_name: {
        fontSize: 30,
        fontWeight: "bold",
        color: "#676767ff"
    },

    university_info: {
        fontSize: 22,
        marginTop: 5,
        color: "#676767ff"
    },

    department_info: {
        fontSize: 16,
        marginTop: 5,
        color: "#676767ff"
    },

    author_id: {
        fontSize: 16,
        marginTop: 2,
        color: "#676767ff"
    },
    
    content: {
        display: "flex",
        flexDirection: "column",
        marginTop: 20,
        marginBottom: 20,
    },

    overview: {
        display: "grid",
        gridTemplateColumns: "75% 24%",
        gridTemplateRows: "300px",
        gridColumnGap: "1%",
        alignItems: "center",
        marginBottom: 40
    },

    card : {
        backgroundColor: "#fff",
        borderRadius: 5,
        boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
        transition: "all 0.3s cubic-bezier(.25,.8,.25,1)",
        ":hover": {
            boxShadow: "0 10px 20px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)"
        },
    },

    publicationsCard: {
        display: "grid",
        gridTemplateRows: "min-content auto"
    },

    awardsCard: {
        display: "grid",
        minHeight: "350px",
        gridTemplateRows: "min-content auto"
    },


    seperator: {
        backgroundColor: "#d2d2d2ff",
        height: 1
    },
    
    info_container: {
        display: "grid",
        gridTemplateRows: "1fr 1px 1fr 1px 1fr",
        height: "300px"
    },

    info_section: {
        width: "100%",
        padding: 20,
        paddingLeft: 40,
    },

    info_section_label: {
        fontSize: "1.2em",
        marginBottom: 5,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },

    info_section_value: {
        fontSize: "1em",
        fontStyle: "italic",
        color: "#5a5a5aff"
    },    
    
    trend_chart_container: {
        height: 280,
        marginTop: 10,
        display: "flex",
        alignItems: "center"
    },
    
    charts_container: {
        display: "grid",
        gridTemplateColumns: "49% 49%",
        gridTemplateRows: "350 450",
        gridColumnGap: "2%",
        gridRowGap: "20px",
    },

    coInvestigatorTabContainer : {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: "transparent",
        borderRadius: 2,
        height: 50,
        marginLeft: 40,
        marginRight: 0,
        overflowX: "auto"
    },

    coInvestigatorsCustomViewContainer : {
        display: "flex",
        flexDirection: "row"
    },

    publicationCardHeader: {
        display: "grid",
        gridTemplateColumns: "auto min-content",
        alignContent: "center"
    },

    coauthorNetworkCardHeader: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: 0,
    },

    customViews : {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: "auto",
        marginRight: 20,
    },

    coauthorChartTypeDrowdown: {
        whiteSpace: 'nowrap',
        marginLeft: "10px",
        marginRight: "10px"
    },

    label_container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },

    card_label: {
        marginLeft: 25,
        marginRight: 10,
        marginTop: 10,
        marginBottom: 10,
        fontSize: 16,
        color: "#5a5a5aff"
    },

    coauthorFilterTypeDrowdown: {
        whiteSpace: 'nowrap',
        marginLeft: "10px",
        marginRight: "10px"
    },
 
    coAuthorCharticons : {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: 10,
        marginRight: 10,
    },

    awardsCardHeader: {
        display: "grid",
        gridTemplateColumns: "auto min-content",
        alignContent: "center"
    },

    awardsBody: {
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        height: 300,
        width: "100%",
        marginTop: 10,
        marginLeft: "auto",
        marginRight: "auto",
        alignItems: "center",
        padding: "0px"
    },

    icon: {
        marginLeft: 10,
        marginRight: 10,
        color: "#5a5a5aff",
        ":hover": {
            cursor: "pointer",
            color: "#006bcfff"
        }
    },

    publicationList: {
        maxHeight: "280px",
        overflowY: "hidden",
        ":hover": {
            overflowY : "auto"
        }
    },

    awardsList: {
        maxHeight: "280px",
        minWidth: "100%",
        overflowY: "hidden",
        ":hover": {
            overflowY : "auto"
        }
    },

    publicationTitle: {
        fontWeight: "bold",
        color: "#4286f4",
        ":hover": {
            textDecoration: "underline",
            cursor: "pointer"
        }
    }


});


// WEBPACK FOOTER //
// ./src/styles/AuthorPublications.ts